const LOCALE = "en-US";
const JAMAICA = "America/Jamaica";
const SQLITE_UTC = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}(\.\d+)?$/;

function safeDate(input: string | number | Date | null | undefined): Date | null {
  if (input == null) return null;
  let d: Date;
  if (typeof input === "string" && SQLITE_UTC.test(input)) {
    d = new Date(input.replace(" ", "T") + "Z");
  } else {
    d = input instanceof Date ? input : new Date(input);
  }
  return Number.isNaN(d.getTime()) ? null : d;
}

function fmt(input: Parameters<typeof safeDate>[0], opts: Intl.DateTimeFormatOptions): string {
  const d = safeDate(input);
  if (!d) return "–";
  return new Intl.DateTimeFormat(LOCALE, opts).format(d);
}

const PUBLIC_DATETIME: Intl.DateTimeFormatOptions = {
  year: "numeric", month: "short", day: "numeric",
  hour: "numeric", minute: "2-digit", hour12: true,
};
const PUBLIC_DATE: Intl.DateTimeFormatOptions = {
  year: "numeric", month: "short", day: "numeric",
};
const PUBLIC_TIME: Intl.DateTimeFormatOptions = {
  hour: "numeric", minute: "2-digit", hour12: true,
};
const PUBLIC_DATE_LONG: Intl.DateTimeFormatOptions = {
  weekday: "long", month: "long", day: "numeric", year: "numeric",
};

export function formatDateTime(input: string | number | Date | null | undefined): string { return fmt(input, PUBLIC_DATETIME); }
export function formatDate(input: string | number | Date | null | undefined): string { return fmt(input, PUBLIC_DATE); }
export function formatTime(input: string | number | Date | null | undefined): string { return fmt(input, PUBLIC_TIME); }
export function formatDateLong(input: string | number | Date | null | undefined): string { return fmt(input, PUBLIC_DATE_LONG); }

const J = { timeZone: JAMAICA } as const;
export function formatJamaicaDateTime(input: string | number | Date | null | undefined): string { return fmt(input, { ...PUBLIC_DATETIME, ...J }); }
export function formatJamaicaDate(input: string | number | Date | null | undefined): string { return fmt(input, { ...PUBLIC_DATE, ...J }); }
export function formatJamaicaTime(input: string | number | Date | null | undefined): string { return fmt(input, { ...PUBLIC_TIME, ...J }); }
export function formatJamaicaDateLong(input: string | number | Date | null | undefined): string { return fmt(input, { ...PUBLIC_DATE_LONG, ...J }); }
